const ascii = (label: string) => label.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '');

/** Machine key: `^[a-z][a-z0-9_]*$`, the shape of attribute, customization and size set keys. */
export function keyFrom(label: string): string {
  return ascii(label)
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^[^a-z]+|_+$/g, '');
}

/** URL handle: `^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$`, the shape of product type slugs. */
export function slugFrom(label: string): string {
  return ascii(label)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** Stored attribute value: `^[a-z0-9][a-z0-9_.-]*$`. "Platinum 950" → "platinum_950", "0.75" stays. */
export function valueCodeFrom(label: string): string {
  return ascii(label)
    .replace(/[^a-z0-9_.-]+/g, '_')
    .replace(/^[^a-z0-9]+|[_.-]+$/g, '');
}
